import { Divider, Space } from '@billy/design-system'
import { ReactElement, useEffect } from 'react'

import { BillAccountSelector } from '@views/bills/elements/BillReconciliationModal/elements/BillAccountSelector'

import { useSegment } from '../../../../hooks'
import { useBankLines, useMultiplePayableSubjects, usePaymentModal } from '../../../paymentReconciliationModal/contexts'
import { SubjectSummary } from '../SubjectSummary'
import { BankLines } from './elements/BankLines'
import { BankLinesActions } from './elements/BankLinesActions'
import { BankLinesModalInfo } from './elements/BankLinesModalInfo'
import { CrossCurrencyPaymentAmount } from './elements/CrossCurrencyPaymentAmount'
import { LinkToManualPayment } from './elements/LinkToManualPayment'

export const BankLinesModalBody = (): ReactElement => {
  const { track } = useSegment()
  const { setPaymentDate, selectedAccount, isCrossCurrency } = usePaymentModal()
  const { bankLinesDifference, hasBankLinesDifference, newestBankLineDate } = useBankLines()
  const { initialSubject } = useMultiplePayableSubjects()

  useEffect(() => {
    track('xxx - expenses - Bank line modal opened')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (newestBankLineDate) {
      setPaymentDate(new Date(newestBankLineDate))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newestBankLineDate])

  return (
    <>
      <SubjectSummary />
      <Space size="s12" />
      <Divider />
      <Space size="s12" />
      {isCrossCurrency && (
        <CrossCurrencyPaymentAmount
          convertedCurrencyId={selectedAccount?.currencyId}
          subjectCurrencyId={initialSubject?.currencyId}
        />
      )}
      <Space size="s12" />
      <BillAccountSelector />
      <Space size="s12" />
      <BankLinesActions />
      <BankLines />
      <BankLinesModalInfo
        isCrossCurrency={isCrossCurrency}
        showDifferenceSelector={hasBankLinesDifference}
        bankLinesDifference={bankLinesDifference}
      />
      {initialSubject && <LinkToManualPayment />}
    </>
  )
}
